import {changeSvg as Icon__small__changeSvg} from '../Icon__small/Icon__small--change.js'

export var change = {
  name: 'change',
  category: 'icon',
  colorable: true,
  svg: Icon__small__changeSvg,
};
